var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poi-picker"},[_c('rich-button',{staticClass:"poi-picker-btn",attrs:{"disabled":_vm.disabled,"outline":""},on:{"click":_vm.showPopup}},[_vm._v(_vm._s(_vm.showValue))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }